import React from "react";
import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { formatRole } from "../../utils/formatRole";

/**
 * Sidebar user info: shows user's name and role from Redux profile
 */
export default function UserProfileSidebarInfo() {
  const { profile } = useSelector((state) => state.profile);

  if (!profile) {
    return (
      <Typography
        variant="caption"
        color="#fff"
        align="center"
        sx={{ fontWeight: 500, lineHeight: 1.2 }}
      >
        ...
      </Typography>
    );
  }

  const { role } = profile;
  return (
    <Typography
      variant="caption"
      color="#fff"
      align="center"
      sx={{ fontWeight: 500, lineHeight: 1.2 }}
    >
      ({formatRole(role)})
    </Typography>
  );
}
